import { useToken } from "../../user/token";
import { CIS_COUNTRIES } from "../../../constants/countries";

/**
 * @returns {string | undefined}
 */
export const useCountry = () => {
  const token = useToken();

  return token.data?.country
}

export const useIsCisCountry = () => {
  const country = useCountry();

  return CIS_COUNTRIES.includes(country)
}